// Contes gardés sur la tablette : texte en mémoire locale, voix dans le cache du navigateur.
const KEY = "passerelle-kept-stories";
export const STORY_CACHE = "passerelle-contes";
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function getKept() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

const save = (list) => localStorage.setItem(KEY, JSON.stringify(list));

export const isKept = (id) => getKept().some((s) => s.id === id);

const full = (u) => (u.startsWith("http") ? u : `${BACKEND}${u}`);

export async function keepStory(story, audioUrls) {
  const urls = audioUrls.filter(Boolean);
  if (urls.length && "caches" in window) {
    const cache = await caches.open(STORY_CACHE);
    await Promise.all(urls.map((u) => cache.add(new Request(full(u), { credentials: "include" })).catch(() => {})));
  }
  save([{ ...story, kept_audio: urls, kept_at: new Date().toISOString() }, ...getKept().filter((s) => s.id !== story.id)]);
}

export async function forgetStory(id) {
  const story = getKept().find((s) => s.id === id);
  save(getKept().filter((s) => s.id !== id));
  if (story?.kept_audio?.length && "caches" in window) {
    const cache = await caches.open(STORY_CACHE);
    await Promise.all(story.kept_audio.map((u) => cache.delete(full(u))));
  }
}
